import React, { useState } from "react";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

const labelStyle: React.CSSProperties = {
  display: "grid",
  gap: "0.45rem",
  color: "#334155",
  fontWeight: 600,
};

const inputStyle: React.CSSProperties = {
  width: "100%",
  border: "1px solid #d1d5db",
  borderRadius: 12,
  padding: "0.85rem 0.95rem",
  background: "#ffffff",
};

const buttonStyle: React.CSSProperties = {
  border: "none",
  borderRadius: 12,
  background: "#111827",
  color: "#fff",
  padding: "0.85rem 1rem",
  fontWeight: 700,
  cursor: "pointer",
};

export default function ProviderVerificationPage() {
  const [savedAt, setSavedAt] = useState<string | null>(null);
  const [form, setForm] = useState({
    businessRegistrationNumber: "",
    vatNumber: "",
    primaryDocumentUrl: "",
    insuranceDocumentUrl: "",
    complianceNotes: "",
  });

  const updateField =
    (field: keyof typeof form) =>
    (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
      setForm((current) => ({ ...current, [field]: event.target.value }));
    };

  const handleSave = (event: React.FormEvent) => {
    event.preventDefault();
    setSavedAt(new Date().toLocaleTimeString());
  };

  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>Verification status</h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Track compliance readiness, verification evidence, and missing provider requirements.
        </p>
      </section>

      <form onSubmit={handleSave} style={{ display: "grid", gap: "1rem" }}>
        <section style={cardStyle}>
          <div
            style={{
              display: "grid",
              gap: "1rem",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            }}
          >
            <label style={labelStyle}>
              Business registration number
              <input
                style={inputStyle}
                value={form.businessRegistrationNumber}
                onChange={updateField("businessRegistrationNumber")}
              />
            </label>

            <label style={labelStyle}>
              VAT number
              <input
                style={inputStyle}
                value={form.vatNumber}
                onChange={updateField("vatNumber")}
              />
            </label>

            <label style={labelStyle}>
              Primary document URL
              <input
                style={inputStyle}
                value={form.primaryDocumentUrl}
                onChange={updateField("primaryDocumentUrl")}
              />
            </label>

            <label style={labelStyle}>
              Insurance document URL
              <input
                style={inputStyle}
                value={form.insuranceDocumentUrl}
                onChange={updateField("insuranceDocumentUrl")}
              />
            </label>
          </div>
        </section>

        <section style={cardStyle}>
          <label style={labelStyle}>
            Compliance notes
            <textarea
              style={{ ...inputStyle, minHeight: 120, resize: "vertical" }}
              value={form.complianceNotes}
              onChange={updateField("complianceNotes")}
            />
          </label>
        </section>

        <section style={cardStyle}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
            <div style={{ color: "#475569" }}>
              {savedAt ? `Verification saved locally at ${savedAt}` : "No local save yet"}
            </div>
            <button type="submit" style={buttonStyle}>
              Save verification
            </button>
          </div>
        </section>
      </form>
    </div>
  );
}